export default __webpack_public_path__ + "static/media/skygarden_demo_image.73b8222f.png";